import React from "react";

const Home = () => {
  return <h2>This is Home</h2>;
};

export default Home;
